var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 71,
    viewBox: "0 0 76 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.679 0L15 0C6.72897 0 0 6.72897 0 15C0 23.271 6.72897 30 15 30H41.679C49.95 30 56.679 23.271 56.679 15C56.679 6.72897 49.95 0 41.679 0ZM41.679 26.679C35.2392 26.679 30 21.4399 30 15C30 8.5603 35.2392 3.32103 41.679 3.32103C48.1188 3.32103 53.3579 8.5603 53.3579 15C53.3579 21.4399 48.1188 26.679 41.679 26.679Z",
    fill: "#018015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2876 37.3633C68.5589 37.314 67.0244 38.1575 66.11 39.4662C66.0196 39.5955 65.8712 39.6714 65.7134 39.6714C65.4441 39.6714 65.2258 39.453 65.2258 39.1838V37.4571C65.2258 34.8638 63.1108 32.5565 60.5198 32.4475C58.7702 32.3739 57.2122 33.2149 56.2845 34.5319C56.2074 34.6411 56.0974 34.7275 55.967 34.7563C55.6679 34.8224 55.383 34.6215 55.3446 34.3325C55.0284 31.9562 53.061 30.0532 50.6094 29.986C48.5714 29.93 46.8039 31.1145 46.0058 32.8394C45.9666 32.9242 45.8835 32.9797 45.7903 32.9797C45.6592 32.9797 45.553 32.8734 45.553 32.7425V19.0154C45.553 16.2576 43.2962 13.9482 40.539 14.0009C37.867 14.0519 35.7167 16.234 35.7167 18.9182V38.5911H33.2575C30.5413 38.5911 28.3394 40.793 28.3394 43.5092V53.3457C28.3394 62.8527 36.0462 70.5596 45.553 70.5596H57.8486C67.3554 70.5596 75.0623 62.8527 75.0623 53.3457V42.3793C75.0623 39.7498 72.9159 37.4381 70.2876 37.3633Z",
    fill: "#F1AA94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggleIcon.3f72fab0f2587687f13ed0d7128392b9.svg";
export { ForwardRef as ReactComponent };